import { GoalAction } from './goal.action';
import {
	LEAD_SKIP_GOAL_INFO,
	UPDATE_GOAL_DATA,
	GOAL_goalId,
	GOAL_Amount,
	GOAL_GoalType,
	GOAL_TargetAmount,
	GOAL_BirthYear
} from './goal.constant';
// import { TGoal } from './goal.model';
import { TLeadGoalsResponse } from '../../models/goals-info-response';
import { TGoal } from '@assetmark/goal-components/dist/models/goal';

export type GoalContextState = {
	goalId: string;
	goals: TGoal;
	updateGoalData: (goal: TLeadGoalsResponse) => void;
	updateGoalId: (goalId: string) => void;
	goalAmount: (amount: number) => void;
	goalGoalType: (amount: number) => void;
	goalTargetAmount: (amount: number) => void;
	goalBirthYear: (year: number) => void;
};

export const initialState: GoalContextState = {
	goalId: '',
	goals: {
		GoalId: 0,
		//InvestorId?: number;
		GoalType: 0,
		Amount: 0,
		TargetAmount: 0,
		//TargetYear?: number;
		//MonthlyIncome?: number;
		//MonthlyIncomeToRetirePercent?: number;
		//SavingsCurrent?: number;
		//AnnualSavings?: number;
		LifeExpectancy: 90,
		Inflation: 0.02,
		//AccountId?: string;
		BirthYear: 0,
		OtherRetirementIncomes: [{ Id: '', IncomeSourceTypeId: 0 }],
		//NetRetirementMonthlyIncome?: number;
		//retirementAge?: number | string;
	},
	updateGoalData: (goal: TLeadGoalsResponse) => {},
	updateGoalId: (goalId: string) => {},
	goalAmount: (amount: number) => {},
	goalGoalType: (goalType: number) => {},
	goalTargetAmount: (amount: number) => {},
	goalBirthYear: (year: number) => {},
};

export function goalContextReducer(state: GoalContextState, action: GoalAction) {
	let newState: any;
	switch (action.type) {
		case UPDATE_GOAL_DATA:
			return {
				...state,
				goals: action.payload,
			};
		case GOAL_goalId:
			return {
				...state,
				goalId: action.payload
			};	
		case GOAL_Amount:
			return {
				...state,
				goals: { ...state.goals, Amount: action.payload }
			};
		case GOAL_GoalType:
			return {
				...state,
				goals: { ...state.goals, GoalType: action.payload }
			};
		case GOAL_TargetAmount:
			return {
				...state,
				goals: { ...state.goals, TargetAmount: action.payload }
			};			
		case GOAL_BirthYear:
			return {
				...state,
				goals: { ...state.goals, BirthYear: action.payload }
			};
		case LEAD_SKIP_GOAL_INFO:
			newState = Object.assign({}, state);
			return newState;
		default: {
			throw new Error(`Unhandled action type: ${action}`);
		}
	}
}
